import React from 'react';
import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';

interface ToastProps {
  title: string;
  description: string;
  variant?: 'default' | 'destructive';
  icon?: React.ReactNode;
}

export const Toaster = () => {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        style: {
          background: 'white',
          color: 'black',
          border: '1px solid #e2e8f0',
        },
      }}
    />
  );
};

export const toast = ({ title, description, variant = 'default', icon }: ToastProps) => {
  const options = {
    style: {
      background: variant === 'destructive' ? '#fee2e2' : 'white',
      border: `1px solid ${variant === 'destructive' ? '#fecaca' : '#e2e8f0'}`,
    },
    icon: icon,
  };

  return sonnerToast(
    <div className="grid gap-1">
      <div className="font-semibold">{title}</div>
      <div className="text-sm text-gray-600">{description}</div>
    </div>,
    options
  );
}; 